import { Injectable } from '@angular/core';
import { DataService } from './core/data.service';
import { Observable } from 'rxjs';
import { ImagemNotaFiscal } from '../_models';

@Injectable({
  providedIn: 'root'
})
export class UcmService extends DataService {
  context = 'ucm';

  obterDocumentoPorId(idProtocolo: number, nomeArquivo: string): Observable<any> {
    return this.get<ImagemNotaFiscal>(`idProtocolo/${idProtocolo}/nomeArquivo/${nomeArquivo}`);
  }

}
